// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"cc596f38","294":"6785b015","340":"42c62f6c","453":"68693753","750":"cd89efaf","821":"c43ea264","840":"c5710c7c","976":"6cd7abb4"}[chunkId] + ".chunk.js";
};